import { useDailyRainfallQueryKey } from 'app/agriculture/hooks/useDailyRainfall/useDailyRainfallQueryKey';
import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { parseDailyRainfallQueryData } from 'app/agriculture/hooks/useDailyRainfall/parseDailyRainfallQueryData';

export function useDailyRainfallValue() {
    const { generateDailyRainfallQueryKey } = useDailyRainfallQueryKey();
    const queryClient = useQueryClient();

    const getDailyRainfallValue = useCallback(
        ({ deviceId }: { deviceId: string }) => {
            const queryKey = generateDailyRainfallQueryKey({ deviceId });
            const data = queryClient.getQueryData(queryKey);
            return parseDailyRainfallQueryData(data);
        },
        [queryClient, generateDailyRainfallQueryKey],
    );

    return { getDailyRainfallValue };
}
